import Axios from 'axios';

const axios = Axios.create({
  baseURL: process.env.VUE_APP_API_URL,
});

const fileAxios = Axios.create({
  baseURL: process.env.VUE_APP_FILE_API_URL,
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});

const axiosPersonal = Axios.create({
  baseURL: process.env.VUE_APP_API_URL_PERSONAL_ANAM,
});

const fileAxiosPersonal = Axios.create({
  baseURL: process.env.VUE_APP_FILE_API_URL_PERSONAL_ANAM,
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});

const axiosAccesoUnico = Axios.create({
  baseURL: process.env.VUE_APP_ACCESO_UNICO_URL,
});

export {
  axios, fileAxios, axiosPersonal, fileAxiosPersonal, axiosAccesoUnico,
};
